const getWidgetScriptUrl = () => {
  const widgetScript = document.getElementById("fuzey-widget");

  if (widgetScript instanceof HTMLScriptElement && widgetScript.src) {
    return widgetScript.src;
  }

  return undefined;
};

export const buildWidgetAssetUrl = (assetUrl: string) => {
  const widgetScriptUrl = getWidgetScriptUrl();

  if (widgetScriptUrl) {
    return new URL(assetUrl, widgetScriptUrl).toString();
  }

  const configuredBaseUrl = process.env.REACT_APP_FUZEY_WIDGET_BASE_URL;

  if (configuredBaseUrl) {
    return `${configuredBaseUrl.replace(/\/+$/, "")}/${assetUrl.replace(/^\/+/, "")}`;
  }

  return assetUrl;
};
